import { onMounted, getCurrentInstance } from "vue";

export function useDynamicMountChild(props: {
  dynamicMountChildMixin_parentComponent: object | undefined;
  dynamicMountChildMixin_isDynamicallyMounted: boolean | undefined;
}) {
  onMounted(() => {
    if (!props.dynamicMountChildMixin_isDynamicallyMounted) {
      return;
    }

    const parent = props.dynamicMountChildMixin_parentComponent;
    if (
      parent &&
      parent.dynamicMountParentMixin_childComponents &&
      Array.isArray(parent.dynamicMountParentMixin_childComponents)
    ) {
      const instance = getCurrentInstance();
      // Push the current component instance
      if (instance?.proxy) {
        parent.dynamicMountParentMixin_childComponents.push(instance.proxy);
      }
    }
  });
}
